__turbopack_context__.v({
  "root": "EmailInput-module__n47woG__root",
});
